import { Routes } from '@angular/router';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { AddressComponent } from './checkout/address/address.component';
import { ConfirmationComponent } from './checkout/confirmation/confirmation.component';
import { LandingComponent } from './landing/landing.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ConfirmationGuard } from './checkout/confirmation/confirmation-guard.service';
import { AddressGuard } from './checkout/address/address-guard.service';
import { AppGuard } from './app-guard.service';
var ɵ0 = {
    step: 'Losbestellung'
}, ɵ1 = {
    step: 'Persönliche Daten & Zahlungsweise'
}, ɵ2 = {
    step: 'Bestellung überprüfen'
};
var appRoutes = [
    {
        path: '',
        redirectTo: '/cart',
        pathMatch: 'full'
    },
    {
        path: 'top',
        redirectTo: '/cart',
        pathMatch: 'full'
    },
    {
        path: 'cart',
        component: CartComponent,
        canActivate: [AppGuard],
        data: ɵ0
    },
    {
        path: 'bestellen',
        component: CheckoutComponent,
        children: [
            { path: '', redirectTo: 'address', pathMatch: 'full' },
            {
                path: 'address',
                component: AddressComponent,
                canActivate: [AddressGuard],
                data: ɵ1
            },
            {
                path: 'bestaetigung',
                component: ConfirmationComponent,
                canActivate: [ConfirmationGuard],
                data: ɵ2
            }
        ]
    },
    {
        path: 'landing',
        component: LandingComponent
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2 };
